// "Every row" includes the row being filled in, so a sum reads as
// the total up to and including the current row.
export const AGGREGATIONS = [
  {value: 'agg_sum', label: 'Sum of every row'},
  {value: 'agg_avg', label: 'Average of every row'},
  {value: 'agg_min', label: 'Minimum of every row'},
  {value: 'agg_max', label: 'Maximum of every row'}
];

export const AGGREGATE_OPERATORS = AGGREGATIONS.map(aggregation => aggregation.value);

// A new aggregation starts without a target so the user has to pick the question being totalled.
export const BLANK_AGGREGATE = {'agg_sum': [null]};

// Only a repeated numeric answer can be aggregated across rows. Sheet setup answers are the same on
// every row, so totalling them would just multiply one answer by the row count.
const AGGREGATABLE_TYPES = ['NUMERIC', 'MEASURED_NUMERIC'];

export function getAggregatableVariables(variables) {
  return Object.keys(variables || {})
    .filter(key => !variables[key].context && AGGREGATABLE_TYPES.indexOf(variables[key].type) >= 0)
    .reduce((map, key) => {
      map[key] = variables[key];
      return map;
    }, {});
}
